import {IconButton} from '@primer/react'
import {CheckIcon, UndoIcon} from '@primer/octicons-react'
import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {useResolveThreadMutation} from '../../../../mutations/use-resolve-thread-mutation'
import {useUnresolveThreadMutation} from '../../../../mutations/use-unresolve-thread-mutation'
import {getThreadPreviewsLineAndFileKeysFromThread} from '../../../../page-data/loaders/use-thread-previews'
import {isLoggedIn} from '@github-ui/client-env'

export function ThreadActions({thread}: {thread: Thread}) {
  const {filePath, lineKey} = getThreadPreviewsLineAndFileKeysFromThread(thread)
  const {mutate: resolveThread, isPending: isResolving} = useResolveThreadMutation(filePath ?? '', lineKey)
  const {mutate: unresolveThread, isPending: isUnresolving} = useUnresolveThreadMutation(filePath ?? '', lineKey)

  const userCanResolve = isLoggedIn()

  const handleToggleResolve = () => {
    if (thread.isResolved) {
      unresolveThread({threadId: thread.id})
    } else {
      resolveThread({threadId: thread.id})
    }
  }

  if (!userCanResolve) {
    return null
  }

  return (
    <IconButton
      icon={thread.isResolved ? UndoIcon : CheckIcon}
      aria-label={thread.isResolved ? 'Unresolve conversation' : 'Resolve conversation'}
      variant="invisible"
      size="small"
      onClick={handleToggleResolve}
      disabled={isResolving || isUnresolving}
      loading={isResolving || isUnresolving}
    />
  )
}
